import React, { useState, useEffect } from 'react';
import './SettingsPanel.css';

const SettingsPanel = ({ isOpen, onClose, userProfile, onUpdateProfile }) => {
  const [settings, setSettings] = useState({
    notifications: true,
    soundEffects: true,
    hapticFeedback: true,
    darkMode: false,
    reminderTime: '09:00'
  });

  useEffect(() => {
    // Load settings from localStorage
    const savedSettings = localStorage.getItem('prettyHabitsSettings');
    if (savedSettings) {
      setSettings(JSON.parse(savedSettings));
    }
  }, []);

  const updateSetting = (key, value) => {
    const newSettings = { ...settings, [key]: value };
    setSettings(newSettings);
    localStorage.setItem('prettyHabitsSettings', JSON.stringify(newSettings));
  };

  const handleProfileUpdate = (field, value) => {
    const updatedProfile = { ...userProfile, [field]: value };
    onUpdateProfile(updatedProfile);
  };

  if (!isOpen) return null;

  return (
    <div className="settings-overlay">
      <div className="settings-panel">
        <div className="settings-header">
          <h2>Settings</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="settings-content">
          {/* Profile Settings */}
          <div className="settings-section">
            <h3>Profile</h3>
            <div className="setting-item">
              <label>Name</label>
              <input
                type="text"
                value={userProfile.name}
                onChange={(e) => handleProfileUpdate('name', e.target.value)}
                className="setting-input"
              />
            </div>
            <div className="setting-item">
              <label>Skin Type</label>
              <select
                value={userProfile.skinType}
                onChange={(e) => handleProfileUpdate('skinType', e.target.value)}
                className="setting-select"
              >
                <option value="dry">Dry</option>
                <option value="oily">Oily</option>
                <option value="combination">Combination</option>
                <option value="sensitive">Sensitive</option>
                <option value="normal">Normal</option>
              </select>
            </div>
            <div className="setting-item">
              <label>Age Range</label>
              <select
                value={userProfile.ageRange}
                onChange={(e) => handleProfileUpdate('ageRange', e.target.value)}
                className="setting-select"
              >
                <option value="teens">Under 20</option>
                <option value="20s">20-29</option>
                <option value="30s">30-39</option>
                <option value="40s">40-49</option>
                <option value="50plus">50+</option>
              </select>
            </div>
          </div>

          {/* App Settings */}
          <div className="settings-section">
            <h3>Preferences</h3>
            <div className="setting-item">
              <label>
                <input
                  type="checkbox"
                  checked={settings.notifications}
                  onChange={(e) => updateSetting('notifications', e.target.checked)}
                />
                <span className="checkbox-label">Enable Notifications</span>
              </label>
            </div>
            <div className="setting-item">
              <label>
                <input
                  type="checkbox"
                  checked={settings.soundEffects}
                  onChange={(e) => updateSetting('soundEffects', e.target.checked)}
                />
                <span className="checkbox-label">Sound Effects</span>
              </label>
            </div>
            <div className="setting-item">
              <label>
                <input
                  type="checkbox"
                  checked={settings.hapticFeedback}
                  onChange={(e) => updateSetting('hapticFeedback', e.target.checked)}
                />
                <span className="checkbox-label">Haptic Feedback</span>
              </label>
            </div>
            <div className="setting-item">
              <label>Daily Reminder Time</label>
              <input
                type="time"
                value={settings.reminderTime}
                onChange={(e) => updateSetting('reminderTime', e.target.value)}
                className="setting-input"
              />
            </div>
          </div>

          {/* Data Management */}
          <div className="settings-section">
            <h3>Data</h3>
            <div className="setting-item">
              <button 
                className="danger-button"
                onClick={() => {
                  if (window.confirm('Are you sure you want to reset all data? This cannot be undone.')) {
                    localStorage.clear();
                    window.location.reload();
                  }
                }}
              >
                Reset All Data
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPanel;
